<app-catalog-page-card title="BOND PROCEED">
  <app-catalog-table-toolbar
    datatableId="kt_bond_proceed_datatable"
    searchPlaceholder="Search bond proceed records..."
    addButtonLabel="Add Bond Proceed"
    addModalId="create_bond_proceed_modal"
    refreshAriaLabel="Refresh bond proceed"
    [disableRefresh]="isLoading()"
    (refresh)="loadRows()"
  ></app-catalog-table-toolbar>

  <app-catalog-crud-modal
    modalId="create_bond_proceed_modal"
    title="Create Bond Proceed"
    submitLabel="Create Bond Proceed"
    [submitting]="isCreating()"
    [formError]="createFormError()"
    (submit)="onCreate()"
    (cancel)="resetCreateForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="createForm">
        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-bond-proceed-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="create-bond-proceed-name"
            type="text"
            class="kt-input"
            maxlength="20"
            formControlName="name"
            [attr.aria-invalid]="shouldShowCreateFieldError('name')"
          />

          @if (shouldShowCreateRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowCreateMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 20 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-bond-proceed-description">Description</label>
          <input
            id="create-bond-proceed-description"
            type="text"
            class="kt-input"
            maxlength="20"
            formControlName="description"
            [attr.aria-invalid]="shouldShowCreateFieldError('description')"
          />

          @if (shouldShowCreateMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 20 characters.</div>
          }
        </div>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#edit_bond_proceed_modal"
  ></button>

  <app-catalog-crud-modal
    modalId="edit_bond_proceed_modal"
    title="Edit Bond Proceed"
    submitLabel="Save Changes"
    [submitting]="isUpdating()"
    [formError]="editFormError()"
    (submit)="onUpdate()"
    (cancel)="resetEditForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="editForm">
        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-bond-proceed-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="edit-bond-proceed-name"
            type="text"
            class="kt-input"
            maxlength="20"
            formControlName="name"
            [attr.aria-invalid]="shouldShowEditFieldError('name')"
          />

          @if (shouldShowEditRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowEditMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 20 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-bond-proceed-description">Description</label>
          <input
            id="edit-bond-proceed-description"
            type="text"
            class="kt-input"
            maxlength="20"
            formControlName="description"
            [attr.aria-invalid]="shouldShowEditFieldError('description')"
          />

          @if (shouldShowEditMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 20 characters.</div>
          }
        </div>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#delete_bond_proceed_confirm_modal"
  ></button>

  <app-catalog-delete-confirm-modal
    modalId="delete_bond_proceed_confirm_modal"
    title="Remove Bond Proceed"
    message="Are you sure you want to remove this bond proceed?"
    confirmLabel="Remove Bond Proceed"
    [confirming]="deletingId() !== null"
    (confirm)="confirmDelete()"
    (cancel)="cancelDelete()"
  ></app-catalog-delete-confirm-modal>

  @if (hasAlert()) {
    <div
      class="kt-alert kt-alert-light"
      [class.kt-alert-success]="alertVariant() === 'success'"
      [class.kt-alert-destructive]="alertVariant() === 'destructive'"
      role="alert"
    >
      <div class="kt-alert-icon">
        <i class="ki-filled ki-information" aria-hidden="true"></i>
      </div>

      <div class="grow">
        <div class="kt-alert-title"><strong>{{ alertTitle() }}</strong></div>

        @if (alertMessage()) {
          <div class="kt-alert-text">{{ alertMessage() }}</div>
        }
      </div>

      <div class="kt-alert-toolbar">
        <div class="kt-alert-actions">
          <button
            type="button"
            class="kt-alert-close"
            aria-label="Dismiss alert"
            (click)="dismissAlert()"
          >
            <i class="ki-filled ki-cross" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  }

  @if (isLoading()) {
    <div class="catalog-loading" role="status" aria-live="polite" aria-label="Loading bond proceeds">
      <span class="catalog-loading-spinner" aria-hidden="true"></span>
      <span class="catalog-loading-text">Loading...</span>
    </div>
  }

  @if (!isLoading() && errorMessage()) {
    <div class="kt-alert kt-alert-destructive flex items-center justify-between gap-3">
      <span>{{ errorMessage() }}</span>
      <button type="button" class="kt-btn kt-btn-sm kt-btn-light" (click)="loadRows()">Retry</button>
    </div>
  }

  @if (!isLoading() && !errorMessage()) {
    <div
      id="kt_bond_proceed_datatable"
      class="kt-card-table"
      data-kt-datatable="true"
      data-kt-datatable-page-size="20"
      data-kt-datatable-state-save="true"
      data-kt-datatable-state-namespace="bond-proceed-datatable"
      (click)="onTableActionClick($event)"
    >
      <div class="kt-table-wrapper kt-scrollable">
        <table class="kt-table" data-kt-datatable-table="true">
          <thead>
            <tr>
              <th scope="col" data-kt-datatable-column="name">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Name</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="description">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Description</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th
                scope="col"
                data-kt-datatable-column="actions"
                data-kt-datatable-column-sort="false"
                class="text-end"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            @if (rows().length === 0) {
              <tr>
                <td colspan="3" class="text-center text-secondary-foreground py-6">
                  No bond proceeds found.
                </td>
              </tr>
            } @else {
              @for (item of rows(); track item.id) {
                <tr>
                  <td>{{ item.name }}</td>
                  <td>{{ item.description || '-' }}</td>
                  <td class="text-end">
                    <span class="inline-flex gap-2.5">
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Edit bond proceed"
                        data-action="edit-bond-proceed"
                        [attr.data-bond-proceed-id]="item.id"
                        [disabled]="deletingId() !== null || isUpdating()"
                      >
                        <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Remove bond proceed"
                        data-action="delete-bond-proceed"
                        [attr.data-bond-proceed-id]="item.id"
                        [disabled]="deletingId() !== null"
                      >
                        <i class="ki-filled ki-trash" aria-hidden="true"></i>
                      </button>
                    </span>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="flex items-center justify-between gap-4 flex-wrap px-5 py-4">
        <div data-kt-datatable-info="true" class="kt-datatable-info text-sm text-secondary-foreground"></div>

        <div class="kt-datatable-length flex items-center gap-3">
          <select data-kt-datatable-size="true" class="kt-select kt-select-sm w-20"></select>
          <div data-kt-datatable-pagination="true" class="kt-datatable-pagination flex items-center gap-2"></div>
        </div>
      </div>
    </div>
  }
</app-catalog-page-card>
